/** @import {NewAccount, Product} from "../contexts/CustomerDataProviderTypes" */

//product level urls (can possibly be removed after refactor towards product type is finished)
export const onlineFlexiSaverUrlSegment = () => productKeys.OnlineFlexiSaver.replace(/_/g, '-');
export const fixedRateSaverUrlSegment = () => productKeys.FixedRateSaver.replace(/_/g, '-');
export const noticeSaverUrlSegment = () => productKeys.NoticeSaver.replace(/_/g, '-');
export const fixedRateCashISAUrlSegment = () => productKeys.FixedRateCashISA.replace(/_/g, '-');

export const productCodeToUrlSegment = (/** @type {string} */ code) => code.replace(/_/g, '-');

//product type level URL (for pages where we want to group products by type)
export const easyAccessUrlSegment = () => "ofs";
export const fixedTermUrlSegment = () => "frs";
export const noticeUrlSegment = () => "ns";
export const fixedRateCashISATypeUrlSegment = () => "fisa";

export const productKeys = {
    OnlineFlexiSaver: 'ofs',
    FixedRateSaver: 'frs_1yr',
    NoticeSaver: 'ns_90d',
    FixedRateCashISA: 'fisa_1yr',
};

export const productTypes = {
    EasyAccess: 'EASY_ACCESS',
    FixedTerm: 'FIXED_TERM',
    Notice: 'NOTICE_SAVER',
    FixedRateCashISA: 'FIXED_RATE_CASH_ISA',
    InstantAccessCashISA: 'INSTANT_ACCESS_CASH_ISA'
};
export const allProductTypes = [productTypes.FixedRateCashISA, productTypes.EasyAccess, productTypes.FixedTerm, productTypes.Notice]


export const isOnlineFlexiSaver = (/** @type {string} */ url) => {
    if (!url)
        return false;

    const lastSegment = url.split("/").pop();

    return onlineFlexiSaverUrlSegment() === lastSegment;
};

export const isFixedRateSaver = (/** @type {string} */ url) => {
    if (!url)
        return false;

    const lastSegment = url.split("/").pop();

    return fixedRateSaverUrlSegment() === lastSegment;
};

export const isNoticeSaver = (/** @type {string} */ url) => {
    if (!url)
        return false;

    const lastSegment = url.split("/").pop();

    return noticeSaverUrlSegment() === lastSegment;
};

export const isFixedRateCashISA = (/** @type {string} */ url) => {
    if (!url)
        return false;

    const lastSegment = url.split("/").pop();

    return fixedRateCashISAUrlSegment() === lastSegment;
};

export const mapProductCodeFromUrl = (/** @type {string} */ url) => {
    if (!url)
        return null;

    const lastSegment = url.split("/").pop();

    if (onlineFlexiSaverUrlSegment() === lastSegment)
        return productKeys.OnlineFlexiSaver;

    if (fixedRateSaverUrlSegment() === lastSegment)
        return productKeys.FixedRateSaver;

    if (noticeSaverUrlSegment() === lastSegment)
        return productKeys.NoticeSaver;

    if (fixedRateCashISAUrlSegment() === lastSegment)
        return productKeys.FixedRateCashISA;

    return null;
};

export const mapProductTypeFromUrl = (/** @type {string} */ url) => {
    const lastSegment = url.split("/").pop();
    switch (lastSegment){
        case easyAccessUrlSegment(): return productTypes.EasyAccess
        case fixedTermUrlSegment(): return productTypes.FixedTerm
        case noticeUrlSegment(): return productTypes.Notice
        case fixedRateCashISATypeUrlSegment(): return productTypes.FixedRateCashISA
    }
}

// This method takes multiple types - not clear on how to tackle this best
export const getProductByType = (/** @type {NewAccount[] | Product[] | undefined} */ products, /** @type {string} */ productType) => {
    return products?.filter(p => 
        //@ts-expect-error there's a better way to do this
        p.productType === productType || 
        //@ts-expect-error there's a better way to do this
        p.type === productType
    ) || [];
}
